import { css } from '@emotion/react';
import { gray6 } from 'styles/global_defaults/colors';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

const styles = css`
  display: flex;
  width: 100%;
  border: 1px solid ${gray6};
  border-radius: ${quarterSpacing}px;

  .tab {
    width: ${quarterSpacing}px;
    background-color: ${gray6};
    border-top-left-radius: ${quarterSpacing}px;
    border-bottom-left-radius: ${quarterSpacing}px;
  }
  .placeholder-content {
    height: 93px;
  }
  .calendar-placeholder {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${gray6};
  }
  .placeholder-bar {
    width: 75%;
  }
  .short-bar {
    width: 50%;
  }
`;

const SessionLoadingPlaceholder = () => (
  <div css={styles} className='mt-2'>
    <div className='tab' />
    <div className='placeholder-content px-4 align-content-center w-100'>
      <div className='d-flex align-items-center'>
        <div className='loading calendar-placeholder' />
        <div className='loading placeholder-bar short-bar ml-2' />
      </div>
      <div className='loading placeholder-bar ml-0 mt-2' />
    </div>
  </div>
);

export default SessionLoadingPlaceholder;
